<template>
    <div class="content-box">
         <div class="content">
             <div class="title-box">
                 <div class="title">
                     <div class="title-text">合作模式</div>
                     <div class="title-e">COOPERATION MODEL</div>
                     <div class="title-line"></div>
                 </div>
             </div>
             <div class="describe">
                 平台可为充电场投资商提供多种合作模式，投资商可根据自身实际情况选择适合自己的合作模式。
             </div>

             <div class="describe-characteristic mt">
                 <table>
                     <tr>
                         <td>模式/项目</td>
                         <td>
                             <div>建站方案策划</div>
                         </td>
                         <td>
                             <div>场站建设实施</div>
                         </td>
                         <td>
                             <div>场站委托运营</div>
                         </td>
                     </tr>
                     <tr>
                         <td>建站策划</td>
                         <td><span></span></td>
                         <td></td>
                         <td></td>
                     </tr>
                     <tr>
                         <td>工程总包</td>
                         <td><span></span></td>
                         <td><span></span></td>
                         <td></td>
                     </tr>
                     <tr>
                         <td>工程总包、代管</td>
                         <td><span></span></td>
                         <td><span></span></td>
                         <td><span></span></td>
                     </tr>
                 </table>
             </div>
         </div>
    </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
}
</script>
<style src="./i_public.less" lang="less" scoped></style>
<!--<style lang="less" scoped>-->
    <!--.content-box{-->
        <!--width: 100%;-->
        <!--margin: 0px auto;-->
        <!--height: 100%;-->
        <!--background-color: #fbfbfb;-->
        <!--font-family:PingFangSC-Regular,PingFang SC;-->
        <!--.content{-->
            <!--width: 1200px;-->
            <!--height: 600px;-->
            <!--margin: 0px auto;-->
            <!--padding:20px;-->
            <!--position: relative;-->
            <!--.title-box{-->
                <!--display: flex;-->
                <!--justify-content: space-between;-->
                <!--font-size: 20px;-->
                <!--width: 1000px;-->
                <!--margin: 2% auto;-->
                <!--height: 66px;-->
                <!--text-align: left;-->
                <!--.title-text {-->
                    <!--color: #05123E;-->
                    <!--font-size: 30px;-->
                    <!--font-weight: 500;-->
                <!--}-->
                <!--.title-e {-->
                    <!--font-size: 10px;-->
                    <!--color: #6684D0;-->
                    <!--line-height: 30px;-->
                    <!--letter-spacing: 1px;-->
                <!--}-->
                <!--.title-line {-->
                    <!--background: linear-gradient(90deg,  #099AFF, #3AFEFE);-->
                    <!--height: 2px;-->
                    <!--width: 30px;-->
                    <!--margin: 0 auto;-->
                    <!--border-radius: 1px;-->
                    <!--margin-left: 0;-->
                <!--}-->
                <!--.end-rukou{-->
                    <!--font-size: 14px;-->
                    <!--color: #19C1E7;-->
                    <!--text-align: right;-->
                    <!--line-height: 66px;-->
                    <!--.icon-img{-->
                        <!--background-image: url('./../../../assets/icon_next 2@2x.png');-->
                        <!--display: inline-block;-->
                        <!--width: 24px;-->
                        <!--height: 24px;-->
                        <!--background-repeat: no-repeat;-->
                        <!--background-size: 24px 24px;-->
                        <!--margin-bottom: -6px;-->
                    <!--}-->
                <!--}-->
            <!--}-->
            <!--.describe{-->
                <!--width: 1000px;-->
                <!--margin: 0 auto;-->
                <!--text-align: left;-->
                <!--color: #526BAB;-->
                <!--font-size: 16px;-->
                <!--line-height: 30px;-->
            <!--}-->
            <!--.describe-characteristic{-->
                <!--font-size:14px;-->
                <!--font-family:PingFangSC-Regular,PingFang SC;-->
                <!--font-weight:400;-->
                <!--color:rgba(26,48,104,1);-->
                <!--line-height:20px;-->
                <!--margin: 30px auto;-->
                <!--table{-->
                    <!--margin: 0 auto;-->
                    <!--border-collapse:collapse;-->
                    <!--tr td{-->
                        <!--width: 200px;-->
                        <!--min-width: 100px;-->
                        <!--height: 60px;-->
                        <!--border:1px solid rgba(210,216,232,1);-->
                        <!--span{-->
                            <!--height:20px;-->
                            <!--width: 20px;-->
                            <!--display: inline-block;-->
                            <!--background-image: url('./../../../assets/mobile/m_icon_selected@2x.png');-->
                            <!--background-repeat: no-repeat;-->
                            <!--background-size: 100%;-->
                        <!--}-->
                    <!--}-->
                <!--}-->
            <!--}-->
        <!--}-->
    <!--}-->

    <!--@media screen and (max-width: 900px) {-->
        <!--.describe-characteristic-item{-->
            <!--width: 100px!important;-->
            <!--height:100px!important;-->
            <!--margin: 0 50px;-->
            <!--padding: 20px 10px;-->
            <!--.item-img{-->
                <!--width: 80px!important;-->
                <!--height:80px!important;-->
            <!--}-->
            <!--.item-text{-->
                <!--font-size:14px!important;-->
                <!--line-height:50px;-->
            <!--}-->
        <!--}-->
    <!--}-->
<!--</style>-->